import React from "react";
import { useRecoilValue } from "recoil";
import { gridSearchText } from "../../recoil/atoms";
import {
  NoRowsRendererGrid,
  NoRowsRendererMessage,
  NoRowsRendererSearch,
} from "./Grid.styles";
import { SubTabName, TabName } from "./types";

interface NoRowsRendererProps {
  oppositeRows: string;
  tabType: TabName;
  subTabType: SubTabName;
}

export const NoRowsRenderer: React.FC<NoRowsRendererProps> = ({
  oppositeRows,
  tabType,
  subTabType,
}) => {
  const searchTerm = useRecoilValue(gridSearchText);

  const getText = () => {
    if (tabType === "ORDERED" && subTabType === "DRAFTS") {
      return 'You currently have no draft orders saved. To start a new order, please click "Order Test".';
    }
    if (tabType === "ARCHIVED" && !searchTerm) {
      return "There are no archived orders at the moment.";
    }
    return `Try using a different term or check for typos.${
      oppositeRows ? " Results are available in another tab." : ""
    }`;
  };

  return (
    <NoRowsRendererGrid>
      {searchTerm && (
        <NoRowsRendererSearch>
          {" "}
          {`Search results for "${searchTerm}"`}
        </NoRowsRendererSearch>
      )}
      <NoRowsRendererMessage>{getText()}</NoRowsRendererMessage>
    </NoRowsRendererGrid>
  );
};
